import { Link } from "react-router-dom";
import { ArrowUpRight, MailOpen } from "lucide-react";

/**
 * 30-day rolling email performance row inside the CRM panel.
 */
export default function EmailStatsBlock({ emailStats }) {
  if (!emailStats) return null;
  return (
    <div className="mt-6 pt-6 border-t border-line" data-testid="email-stats-block">
      <div className="flex justify-between items-center mb-4">
        <div>
          <div className="label-eyebrow">Email performance · last 30 days</div>
          <h3 className="font-heading text-lg uppercase mt-1">Outreach signal</h3>
        </div>
        <Link to="/app/outreach" className="text-xs uppercase tracking-widest text-volt inline-flex items-center gap-1">
          View sends <ArrowUpRight className="w-3.5 h-3.5" />
        </Link>
      </div>
      {emailStats.sends === 0 ? (
        <div className="text-sm text-ink-muted" data-testid="email-stats-empty">
          No email outreach in the last 30 days. Once you start sending, you'll see open and click rates here.
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-5 gap-2">
          <EmailStat label="Sent" value={emailStats.sends} testid="es-sent" />
          <EmailStat label="Delivered" value={emailStats.delivered} testid="es-delivered" />
          <EmailStat label="Open rate" value={`${emailStats.open_rate_pct}%`} accent={emailStats.open_rate_pct >= 20} testid="es-open-rate" icon={MailOpen} />
          <EmailStat label="Click rate" value={`${emailStats.click_rate_pct}%`} testid="es-click-rate" />
          <EmailStat label="Bounced" value={emailStats.bounced} danger={emailStats.bounced > 0} testid="es-bounced" />
        </div>
      )}
    </div>
  );
}

function EmailStat({ label, value, accent, danger, testid, icon: Icon }) {
  const cls = danger ? "border-[#FF3B30]/40 text-[#FF3B30]"
                     : accent ? "border-volt/60 text-volt"
                              : "border-line text-white";
  return (
    <div className={`border p-3 ${cls}`} data-testid={testid}>
      <div className="flex items-center justify-between">
        <div className="label-eyebrow text-[10px]">{label}</div>
        {Icon && <Icon className="w-3 h-3 opacity-60" />}
      </div>
      <div className="font-heading text-xl mt-1">{value}</div>
    </div>
  );
}
